<!-- eslint-disable max-len -->
<template>
  <div class="aha-pricing-component">
    <div class="aha-container">
      <div
        v-for="(price, index) in getPrices"
        :key="price.label"
        :class="`column-${index + 1} ${isEditor ? 'editor-wrapper' : ''}`"
        class="aha__card-wrapper"
      >
        <div class="aha__content_pricing-card">
          <section class="recommended" v-if="(index + 1) === 3">
            {{ $i18nPresenter.t('Recommended') }}
          </section>
          <div :class="getCustomCss('aha__banner', price.label)">
            <!-- <div class="aha__banner"> -->
            <section class="pricing-label-icon">
              <h1 class="">
                {{ price.label }} {{ price.planIcon }}
              </h1>
              <p class="" v-html="$i18nPresenter.t(`${price.labelDescription}`)">
              </p>
              <img class="aha__ai_banner" v-if="price.label === 'Pro'" :src="AiImage" />
              <!-- <img class="aha__ai_banner" v-if="price.label === 'Pro'" :src="price.sticker)" /> -->
            </section>
          </div>
          <div class="aha__body_pricing" :class="{'body-free': price.label === 'Free'}">
            <div
              class="aha__price-info"
            >
              <div class="price-box">
                <span class="aha__price">
                  <span v-if="showCurrency(price.label)">{{ symbolCurrency }}</span>{{ setTranslationforPlainText(price.price) }}
                </span>
              </div>
              <div :class="{'opacity-0': (price.price === '0' || price['smaller-price'] === 0 || price.label === 'Enterprise') }">
                <!-- <div class="aha__billing"> -->
                <div class="text-time-plan">
                  {{ $i18nPresenter.t('per month') }}<span v-if="isShowBackToNonEdu">, {{ $i18nPresenter.t('billing yearly') }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="aha__single-user aha__single-user--40" />

          <div class="aha__plan-info" :class="{'aha-plan-free': price.label === 'Free'}">
            <div class="text-center">
              <aha-button
                class="action-button"
                v-if="price.label !== 'Free'"
                type="button"
                :disabled="permission[price.permissionKey] || isCreatingCustomerPortal"
                @click="goToUpgradePage(price)"
              >
                <span v-if="price.label !== 'Enterprise'">{{ $i18nPresenter.t('Buy Now') }}</span>
                <span v-else>{{ $i18nPresenter.t('Speak to Us') }}</span>
                <aha-spinner variant="white" v-if="isCreatingCustomerPortal" />
              </aha-button>
            </div>
            <span>
              <section class="mb-4">
                {{ $i18nPresenter.t(price.description) }}
              </section>
              <div class="aha-list-feature">
                <div class="aha__item_feature">
                  <span class="icon-feature-image"><TickSvg class="tick-svg" :color="price.tickColor" /></span>
                  <div class="limit-audience">
                    <span>{{ $i18nPresenter.t('Audience size:') }}</span>
                    <span
                      class="audience-size"
                      v-tooltip="$i18nPresenter.t('Max. number of people who can join and interact with your presentation simultaneously.')"
                    >
                      {{ $i18nPresenter.t(price.maxParticipants) }}
                    </span>
                  </div>
                </div>
                <div v-for=" feature in price.listFeature " :key="feature">
                  <div class="aha__item_feature ">
                    <span class="icon-feature-image"><TickSvg class="tick-svg" :color="price.tickColor" /></span>
                    {{ $i18nPresenter.t(feature) }}
                  </div>
                </div>
              </div>
              <span v-if="!isEditor" class="aha-more-detail" @click="$emit('learnMore', price.planKey)">
                {{ $i18nPresenter.t('Learn more') }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <SpeakToUsModal
      :isOpenModal="isOpenSpeakToUsModal"
      @hide="closeSpeakToUsModal"
      :email="currentUser.email"
      v-if="isOpenSpeakToUsModal"
      @showThanksModal="showThanksModal"
    />
    <ThanksYourRequestModal
      @closeThanksModal="isThanksRequestModal= false"
      v-if="isThanksRequestModal"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import TickSvg from '@/components-v2/my-plan/user-pricing-v3/TickSvg.vue'
import PaymentLocalizationMixin from './PaymentLocalizationMixin'
import SpeakToUsModal from '@/components-v2/my-plan/user-pricing-v3/SpeakToUsModal.vue'
import ThanksYourRequestModal from '@/components-v2/my-plan/user-pricing-v3/ThanksYourRequestModal.vue'

const AiImage = require('@/assets/images/pricing/ai-powered.svg')

export default {
  components: {
    TickSvg,
    SpeakToUsModal,
    ThanksYourRequestModal,
  },
  mixins: [PaymentLocalizationMixin],
  props: {
    isEditor: {
      type: Boolean,
      default: false,
    },
    permission: {
      type: Object,
      default: () => {},
    },
    planName: {
      type: String,
      default: 'annual',
    },
    isShowBackToNonEdu: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpenSpeakToUsModal: false,
      isThanksRequestModal: false,
      AiImage,
    }
  },
  computed: {

    ...mapState({
      promotionCode: (state) => state.promotionCode,
      currentUser: (state) => state.currentUser,
      isCreatingCustomerPortal: (state) => state.isCreatingCustomerPortal,
    }),

    getPrices() {
      return this.featuresByPlan[this.planName].planPrices.filter((plan) => {
        if (this.isEditor) {
          return !this.permission[plan.permissionKey] && plan.label !== 'Free'
        }
        return true
      })
    },
  },
  methods: {
    ...mapActions(['createCheckoutSessionForPersonPlan', 'createCustomerPortalUpgradeFlowAction']),
    closeModalThanksRequest() {
      this.isThanksRequestModal = false
    },
    showThanksModal() {
      this.isThanksRequestModal = true
    },
    closeSpeakToUsModal() {
      this.isOpenSpeakToUsModal = false
    },
    openSpeakToUsModal() {
      this.isSpeakToUsModalOpen = true
    },
    handleSpeakToUsModalHide() {
      this.isSpeakToUsModalOpen = false
      this.isThanksYourRequestModalOpen = true
    },
    goToUpgradePage(price) {
      if (price.label === 'Enterprise') {
        this.isOpenSpeakToUsModal = true
        return
      }
      const payload = {
        plan: price.planKey,
      }
      if (this.promotionCode) {
        payload.promotionCode = this.promotionCode.code
      }
      if (this.currentUser.plan !== 'free' && !this.currentUser.plan.includes('one-time')) {
        this.createCustomerPortalUpgradeFlowAction(payload)
      } else {
        this.createCheckoutSessionForPersonPlan(payload)
      }
    },

    getCustomCss(baseClass, type) {
      type = type.toLowerCase().replace(' ', '-')
      const cssClasses = {
        aha__banner: {
          free: 'aha__banner_free',
          essential: 'aha__banner_essential',
          pro: 'aha__banner_pro',
          enterprise: 'aha__banner_enterprise',
          'edu-small': 'aha__banner_essential',
          'edu-medium': 'aha__banner_pro',
          'edu-large': 'aha__banner_enterprise',
        },
      }
      return cssClasses[baseClass] ? cssClasses[baseClass][type] : baseClass
    },
    showCurrency(label) {
      return label !== 'Enterprise'
    },
  },
}
</script>
<style scoped>
</style>
